export const UNAUTHORIZED_URLS = [
  '/login',
  '/forget',
  '/forget/confirm',
  '/register',
  '/register/complete',
  '/register/error',
  '/register/update',
]
